<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ijSp9F/tc-custom/9780226653174.jpg?1722579938556" alt="This image is the cover for the book Move On Up"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Move On Up
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>Chicago Tribune</i> Book of 2019, Notable Chicago Reads<br/><br/> A <i>Booklist</i> Top 10 Arts Book of 2019<br/><br/> A <i>No Depression</i> Top Music Book of 2019</b><br/><br/> Curtis Mayfield. The Chi-Lites. Chaka Khan. Chicago’s place in the history of soul music is rock solid. But for Chicagoans, soul music in its heyday from the 1960s to the 1980s was more than just a series of hits: it was a marker and a source of black empowerment. In <i>Move On Up</i>, Aaron Cohen tells the remarkable story of the explosion of soul music in Chicago. Together, soul music and black-owned businesses thrived. Record producers and song-writers broadcast optimism for black America’s future through their sophisticated, jazz-inspired productions for the Dells and many others. Curtis Mayfield boldly sang of uplift with unmistakable grooves like “We’re a Winner” and “I Plan to Stay a Believer.” Musicians like Phil Cohran and the Pharaohs used their music to voice Afrocentric philosophies that challenged racism and segregation, while Maurice White of Earth, Wind, and Fire and Chaka Khan created music that inspired black consciousness. Soul music also accompanied the rise of African American advertisers and the campaign of Chicago’s first black mayor, Harold Washington, in 1983. This empowerment was set in stark relief by the social unrest roiling in Chicago and across the nation: as Chicago’s homegrown record labels produced rising stars singing songs of progress and freedom, Chicago’s black middle class faced limited economic opportunities and deep-seated segregation, all against a backdrop of nationwide deindustrialization.<br/><br/> Drawing on more than one hundred interviews and a music critic’s passion for the unmistakable Chicago soul sound, Cohen shows us how soul music became the voice of inspiration and change for a city in turmoil.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aaron Cohen
      </h2>
      
      <p class="authorDescription body article"><B>Aaron Cohen</B> covers the arts for numerous publications and teaches English, journalism, and humanities at the City Colleges of Chicago. He is the author of <I>Aretha Franklin’s "Amazing Grace".</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18aff914